var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-select',{attrs:{"options":_vm.workPlaces},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }